import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import ProfileTitle from '../../mobile/profile/ProfileTitle';
import ProfileRing from './ProfileRing';
import ProfileRPGO from './ProfileRPGO';

import { textInCapitalCase } from '../../../../helpers/TextHelper';
import { showPointsInSideBar } from '../../../../helpers/BankHelper';
import { useProfileStyles } from './styles';

const ProfileInfo = () => {
  const categoryType = useSelector((state) => state.loyaltyReducer.category);
  const classes = useProfileStyles();
  const profile = useSelector((state) => state.profileReducer.profile);
  const { points, pointsStatus } = useSelector((state) => state.bankReducer);
  const { Points: totalPoints, subscribed } = points;
  const name = `${profile.firstName} ${profile.lastName}`;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      alignContent="center"
      style={{ marginBottom: 20 }}
    >
      <ProfileTitle
        title={
          <p className={classes.centerText}>
            ¡Hola <strong>{name}</strong>!
          </p>
        }
      />
      <ProfileRing
        totalPoints={totalPoints}
        firstName={profile.firstName}
        lastName={profile.lastName}
        categoryType={categoryType}
      />
      {categoryType ? (
        <React.Fragment>
          {categoryType !== 'Sin Categoría' && (
            <Typography variant="h2" className={classes.text}>
              Eres Cliente:&nbsp;
              <strong>{textInCapitalCase(categoryType)}</strong>
            </Typography>
          )}
        </React.Fragment>
      ) : (
        <Skeleton
          className={classes.text}
          variant="rect"
          width={250}
          height={40}
        />
      )}
      {showPointsInSideBar() && (
        <React.Fragment>
          {pointsStatus === 'loading' || pointsStatus === 'idle' ? (
            <Skeleton
              className={classes.text}
              variant="rect"
              width={250}
              height={40}
            />
          ) : (
            <ProfileRPGO subscribed={subscribed} totalPoints={totalPoints} />
          )}
        </React.Fragment>
      )}
    </Box>
  );
};

export default ProfileInfo;
